module.exports = require('./helpers/bundle-url').getBundleURL('8kqgc') + "icon-whatsapp.35b7a39e.png";